/* FONTE ÚNICA DE EVENTOS — parte de navegador.
   ---------------------------------------------------------------------------
   Publica no dataLayer os dois fatos que só existem depois de uma ação do
   cliente: `cofre_product_added_to_cart` e `cofre_checkout_started`.
   O contrato e o resto da divisão estão em `snippets/cofre-alado-tracking.liquid`.

   O QUE MUDOU EM 21/08/2026, e por quê:

   1. Nomes. Era `add_to_cart` / `begin_checkout` / `select_item` — nomes do GA4
      publicados direto pelo tema. Agora o tema publica o fato COMERCIAL
      (`cofre_*`) e o mapeamento para GA4/Meta/TikTok/Ads acontece dentro do
      GTM. Sem isso, cada plataforma nova exige mexer no tema.

   2. `select_item` foi REMOVIDO. Ele não está no contrato e disparava em
      qualquer clique em card, inclusive nos que não levavam a lugar nenhum.

   3. Add to cart só depois da adição EFETIVA. Antes disparava no `submit` do
      formulário — ou seja, na INTENÇÃO. Se a requisição falhasse (esgotado,
      erro de rede), o evento já tinha ido. Agora a resposta do `/cart/add` é
      observada e o evento só sai com status 2xx. Isso vale para o `fetch` e
      para o XHR, porque o Horizon usa os dois em caminhos diferentes.        */

(function () {
  var CA = window.CofreAlado;
  if (!CA) return; /* sem o snippet do <head>, não há contrato — não inventa */

  function push(evento, idDoEvento, valor, itens) {
    var o = CA.base(evento, idDoEvento, valor);
    o.ecommerce = { items: itens || [] };
    CA.push(o);
  }

  /* Itens do carrinho, lidos da resposta do próprio Shopify. É a única fonte
     que sabe o que ENTROU, incluindo quantidade e variante corretas. */
  function itensDaResposta(json) {
    var linhas = json && json.items ? json.items : (json && json.id ? [json] : []);
    return linhas.map(function (l) {
      return {
        item_id: String(l.variant_id || l.id || ''),
        item_name: l.product_title || l.title || '',
        item_brand: 'Cofre Alado',
        item_category: l.product_type || 'Producto',
        item_variant: l.variant_title || '',
        price: (l.final_price != null ? l.final_price : l.price) / 100,
        quantity: l.quantity || 1
      };
    });
  }

  function somar(itens) {
    return itens.reduce(function (t, i) { return t + i.price * i.quantity; }, 0);
  }

  function adicionou(json) {
    var itens = itensDaResposta(json);
    if (!itens.length) return;
    /* id do fato = variante + minuto. Duas adições do mesmo item em segundos
       são o mesmo fato para a plataforma; adições distintas ao longo da visita
       geram ids distintos. */
    var chave = itens[0].item_id + '-' + Math.floor(CA.agora() / 60);
    push('cofre_product_added_to_cart', CA.idEvento('atc', chave), somar(itens), itens);
  }

  /* --- fetch ------------------------------------------------------------- */
  var fetchOriginal = window.fetch;
  if (typeof fetchOriginal === 'function') {
    window.fetch = function (entrada, opcoes) {
      var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
      var ehAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var p = fetchOriginal.apply(this, arguments);
      if (!ehAdd) return p;
      return p.then(function (resposta) {
        if (resposta && resposta.ok) {
          /* clone: consumir o corpo original quebraria quem chamou */
          resposta.clone().json().then(adicionou).catch(function () {});
        }
        return resposta;
      });
    };
  }

  /* --- XMLHttpRequest ---------------------------------------------------- */
  var abrir = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    this.__caAdd = /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
    return abrir.apply(this, arguments);
  };
  var enviar = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__caAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          try { adicionou(JSON.parse(this.responseText)); } catch (e) {}
        }
      });
    }
    return enviar.apply(this, arguments);
  };

  /* --- checkout iniciado -------------------------------------------------
     Dispara quando o cliente sai para o checkout de verdade. O id do fato é o
     token do carrinho: recarregar a página ou voltar e clicar de novo no mesmo
     carrinho não cria um segundo begin_checkout. */
  var jaFoi = false;
  document.addEventListener('click', function (e) {
    var alvo = e.target.closest(
      'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-ca-checkout]'
    );
    if (!alvo || jaFoi) return;
    jaFoi = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        var itens = itensDaResposta(carrinho);
        var token = (carrinho && carrinho.token) || 'sem-token';
        push('cofre_checkout_started', CA.idEvento('ic', token), somar(itens), itens);
      })
      .catch(function () { jaFoi = false; });
  }, true);
})();
